import { toast } from 'react-toastify';
import { cancelFun } from '../../../api/userAPI';
import { getTypeShort } from '../../../utils/getType';

export const handleBooking = async (data, setShowModal, typeSel) => {
    try {
        const res = await cancelFun(getTypeShort(typeSel), data._id);

        if (res.status === 200) {
            setShowModal(false);
            toast.success(res.data.message);
        } else {
            toast.error('Failed to cancel booking. Please try again.');
        }
    } catch (err) {
        console.log(err);
        toast.error('Something went wrong!');
    }
};
